import BackgroundTypesSave from '@components/background-types/save';
import { DEFAULT_CSS_CLASS } from '@constants';
import { getBlockClassNames } from '@components/class-dropdown';
import { generateSpacingClasses } from '@components/spacing-selector/utils';
import classnames from 'classnames';

const {
  blockEditor: { InnerBlocks, useBlockProps },
} = wp;

const Save = ({ attributes }) => {
  const {
    blockId,
    containerType,
    backgroundType,
    backgroundGradientOptions,
    backgroundColorOptions,
    backgroundImageOptions,
    backgroundImageAndColorOptions,
    imageAsBackgroundOptions,
    imageGradientBackgroundOptions,
    backgroundVideoOptions,
    blockClassNames,
    spacingTop,
    spacingBottom,
    anchorId,
    printBackgroundStyles,
  } = attributes;

  const defaultBlockCssClass = DEFAULT_CSS_CLASS.SECTION;
  const defaultBlockDynamicCssClass = `${defaultBlockCssClass}-${blockId}`;
  const classNames = getBlockClassNames(blockClassNames);
  const spacingTopClasses = generateSpacingClasses(spacingTop);
  const spacingBottomClasses = generateSpacingClasses(spacingBottom);
  const sectionId =
    anchorId.toString().length > 0
      ? anchorId.toLowerCase().replace(/\W/g, '-')
      : '';

  const blockProps = useBlockProps.save({
    ...(sectionId && { id: sectionId }), // Adds the id attribute only when the sectionId is not empty
    className: classnames(
      {
        [`${defaultBlockCssClass}`]: true,
        [`${defaultBlockDynamicCssClass}`]: defaultBlockDynamicCssClass,
        [`${classNames}`]: classNames,
      },
      spacingTopClasses,
      spacingBottomClasses,
    ),
  });

  return (
    <section {...blockProps}>
      <BackgroundTypesSave
        {...{
          blockId,
          defaultBlockCssClass,
          backgroundType,
          backgroundGradientOptions,
          backgroundColorOptions,
          backgroundImageOptions,
          backgroundImageAndColorOptions,
          imageAsBackgroundOptions,
          imageGradientBackgroundOptions,
          backgroundVideoOptions,
          printBackgroundStyles,
        }}
      />
      <div className={containerType}>
        <InnerBlocks.Content />
      </div>
    </section>
  );
};

export default Save;
